import React from 'react';
import { VictoryLine, VictoryLabel } from 'victory';

export const CHART_WIDTH_RATIO = 0.85;

export const CHART_COLORS = {
  induct: '#2563eb',
  stow: '#16a34a',
  pick: '#ef4444',
  wip: '#8b5cf6',
  interval: '#f97316',
  total: '#1e293b',
  palette: [
    '#3b82f6',
    '#10b981',
    '#f43f5e',
    '#f59e0b',
    '#8b5cf6',
    '#ec4899',
    '#06b6d4',
    '#84cc16',
    '#f97316',
    '#6366f1'
  ]
};

export const buildXDomain = (tickValues) =>
  tickValues.length ? [tickValues[0], tickValues[tickValues.length - 1]] : undefined;

export const timeToMinutes = (timeStr) => {
  const [h, m] = (timeStr || '').split(':').map(Number);
  return (h || 0) * 60 + (m || 0);
};
export const buildTimeScale = (categories) => {
  if (!categories?.length) return { minutesMap: {}, tickValues: [], tickFormat: () => '' };
  const raw = categories.map(timeToMinutes);
  const normalized = [raw[0]];
  for (let i = 1; i < raw.length; i++) {
    let val = raw[i];
    while (val < normalized[i - 1]) val += 24 * 60;
    normalized.push(val);
  }
  const minutesMap = {};
  categories.forEach((cat, i) => {
    minutesMap[cat] = normalized[i];
  });
  const tickFormat = (t) => {
    const idx = normalized.indexOf(t);
    return idx >= 0 ? categories[idx] : '';
  };
  return { minutesMap, tickValues: normalized, tickFormat };
};
export const transformChartData = (data, minutesMap) => (data || []).map((d) => ({ ...d, x: minutesMap[d.x] ?? d.x }));

const FormattedLabel = ({ labelComponent, formatFn, ...props }) => {
  const modified = { ...props };
  if (props.datum) {
    modified.datum = { ...props.datum, xName: formatFn(props.datum._x) };
  }
  if (props.activePoints) {
    modified.activePoints = props.activePoints.map((p) => ({ ...p, xName: formatFn(p._x) }));
  }
  return React.cloneElement(labelComponent, modified);
};

export const formatTooltipTitle = (labelComponent, formatFn) => (
  <FormattedLabel labelComponent={labelComponent} formatFn={formatFn} />
);

export const buildIntervalLines = (intervals, minutesMap) => {
  if (!intervals?.length) return [];
  const seen = new Set();
  const lines = [];
  intervals.forEach((interval) => {
    if (!seen.has(interval.startLabel)) {
      seen.add(interval.startLabel);
      lines.push({ time: minutesMap[interval.startLabel] ?? timeToMinutes(interval.startLabel), name: interval.name });
    }
  });
  return lines;
};

export const renderIntervalLines = (intervalLines, yMax) =>
  intervalLines.map(({ time, name }) => (
    <VictoryLine
      key={`iv-${time}`}
      data={[
        { x: time, y: 0 },
        { x: time, y: yMax }
      ]}
      style={{ data: { stroke: CHART_COLORS.interval, strokeWidth: 1.5, strokeDasharray: '6,4', opacity: 0.4 } }}
      labels={[name]}
      labelComponent={
        <VictoryLabel dy={-10} style={{ fill: CHART_COLORS.interval, fontSize: 10, fontWeight: 'bold' }} />
      }
    />
  ));
